'use client';

import BenefitItem from '@/components/megamenu/Benefits';
import FeatureItem from '@/components/megamenu/FeatureItem';

const benefits = [
  'Full product range access',
  'Easy case tracking',
  'Dedicated underwriters',
  'CPD events & resources',
];

export const MegaMenuAboutUsContent = ({ menuItems }) => {
  return (
    <div className="grid grid-cols-5 gap-2">
      {/* Left Section: Menu Items */}
      <div className="h-[460px] px-3 py-9 bg-[#fcfcff] col-span-3">
        <div className="h-[200px] grid grid-cols-2 gap-1">
          {menuItems.map((item, index) => (
            <FeatureItem
              key={index}
              title={item.title}
              description={item.description}
              icon={item.icon}
              href={item.href}
              external={item.external}
            />
          ))}
        </div>
      </div>

      {/* Right Section: Registration CTA */}
      <div className="h-[460px] px-6 py-8 bg-[#f3f4f8] col-span-2 pt-11 flex flex-col justify-between">
        <div>
          <h3 className="mega-menu-featured-content-title mb-4">Why not Register?</h3>
          <p className="about-us-text mb-6">
            Explore how our lifetime mortgages can deliver your customers’ financial objectives. Gain access to our
            full range of lifetime mortgages.
          </p>
          <div className="flex flex-col gap-1">
            {benefits.map((benefit, index) => (
              <BenefitItem key={index} text={benefit} />
            ))}
          </div>
          <div>
            <a href="/professionals/register" className="rounded-lg inline-flex items-center gap-1 mt-6 cursor-pointer">
              <span className="about-us-text-reg">Register now</span>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M2.66669 8H13.3334M13.3334 8L9.33335 4M13.3334 8L9.33335 12"
                  stroke="#006EB7"
                  strokeWidth="1.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
